import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Contact() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <section id="contact" className="contact section light-background">
            <div className="container section-title" data-aos="fade-up">
                <h2>Contact</h2>
                <div>
                    <span>Need Help?</span> <span className="description-title">Contact Us</span>
                </div>
            </div>

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gy-4">
                    <div className="col-lg-12">
                        <div className="row gy-4">
                            <div className="col-lg-4 col-md-6">
                                <div
                                    className="info-item d-flex flex-column justify-content-center align-items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <i className="bi bi-geo-alt"></i>
                                    <h3>Visit Us</h3>
                                    <p className="text-center">
                                        Nau Gaja Peer, College Road,<br />
                                        Ropar, Punjab
                                    </p>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <div
                                    className="info-item d-flex flex-column justify-content-center align-items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                >
                                    <i className="bi bi-telephone"></i>
                                    <h3>Call Us</h3>
                                    <p>
                                        <a href="tel:9988893537">99888-93537</a>
                                    </p>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <div
                                    className="info-item d-flex flex-column justify-content-center align-items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <i className="bi bi-envelope"></i>
                                    <h3>Email Us</h3>
                                    <p>
                                        <a href="mailto:info@ganpaticomputers.com">info@ganpaticomputers.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Optional: Add a simple static message instead of the form */}
                    <div className="col-lg-12 text-center mt-4" data-aos="fade-up" data-aos-delay="500">
                        <p style={{ fontSize: '1.1rem' }}>
                            For any inquiries or to schedule a service, feel free to call, email, or visit our shop. We're here to help!
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;